import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./ChangePassword.module.css";
import {
  Button,
  SubHeadingTitle,
} from "../../components/shared";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

// ✅ Import password validation
import { validatePassword } from "../../utils/Validations";

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const onSubmit = async (formData) => {
    try {
      const fd = new FormData();

      fd.append("current_password", formData.current_password);
      fd.append("new_password", formData.new_password);
      fd.append(
        "new_password_confirmation",
        formData.new_password_confirmation
      );

      const res = await authService.changePasswordUser(fd);

      toast.success(
        res?.data?.message || "Password changed successfully"
      );

      reset();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to change password"
      );
    }
  };

  return (
    <form
      className={styles.container}
      onSubmit={handleSubmit(onSubmit)}
    >
      <SubHeadingTitle
        subTitle={
          <span className={styles.title}>Change Password</span>
        }
      />

      {/* CURRENT PASSWORD */}
      <div className={styles.row}>
        <label className={styles.label}>
          Current Password :
        </label>

        <div className={styles.inputWrapper}>
          <input
            type={showCurrent ? "text" : "password"}
            placeholder="Enter current password"
            {...register("current_password", {
              required: "Current password is required",
            })}
          />

          <span
            onClick={() => setShowCurrent(!showCurrent)}
          >
            {showCurrent ? (
              <AiOutlineEyeInvisible />
            ) : (
              <AiOutlineEye />
            )}
          </span>
        </div>

        <p className={styles.error}>
          {errors?.current_password?.message}
        </p>
      </div>

      {/* NEW PASSWORD */}
      <div className={styles.row}>
        <label className={styles.label}>
          New Password :
        </label>

        <div className={styles.inputWrapper}>
          <input
            type={showNew ? "text" : "password"}
            placeholder="Enter new password"
            {...register("new_password", {
              // ✅ Uses common validatePassword function
              validate: validatePassword,
            })}
          />

          <span
            onClick={() => setShowNew(!showNew)}
          >
            {showNew ? (
              <AiOutlineEyeInvisible />
            ) : (
              <AiOutlineEye />
            )}
          </span>
        </div>

        <p className={styles.error}>
          {errors?.new_password?.message}
        </p>
      </div>

      {/* CONFIRM PASSWORD */}
      <div className={styles.row}>
        <label className={styles.label}>
          Confirm New Password :
        </label>

        <div className={styles.inputWrapper}>
          <input
            type={showConfirm ? "text" : "password"}
            placeholder="Confirm new password"
            {...register("new_password_confirmation", {
              required: "Confirm password is required",

              validate: (value) =>
                value === watch("new_password") ||
                "Passwords do not match",
            })}
          />

          <span
            onClick={() => setShowConfirm(!showConfirm)}
          >
            {showConfirm ? (
              <AiOutlineEyeInvisible />
            ) : (
              <AiOutlineEye />
            )}
          </span>
        </div>

        <p className={styles.error}>
          {errors?.new_password_confirmation?.message}
        </p>
      </div>

      <Button
        title="Update Password"
        type="submit"
        style={styles.updateBtn}
      />
    </form>
  );
};

export default ChangePassword;